import Vue from "vue";
import axios from 'axios'
import asleep from 'await-sleep'

const items = Vue.localStorage.get('quoteItems', {})
const state = {
    items: items,
};

const getters = {
    durationDays: (state) => (pickupDate, returnDate) => {
        if (!pickupDate.isValid() || !returnDate.isValid()) return 0
        return returnDate.diff(pickupDate, 'days') + 1
    },
    quotedItems: (state, getters, rootState, rootGetters) => {
        const items = []
        Object.values(state.items).forEach(function(item) {
            if (!item.assetId) return
            const quotedItem = Object.assign({}, item, {
                days: getters.durationDays(Vue.moment(item.pickupDate), Vue.moment(item.returnDate)),
            })
            items.push(quotedItem)
        })
        return items
    },
    isQuoted: (state) => (assetId) => {
        return state.items[assetId] ? true : false
    },
    totalDays: (state, getters) => {
        return Object.values(state.items).filter(item => item.assetId).reduce((accumulator, item) => getters.durationDays(Vue.moment(item.pickupDate), Vue.moment(item.returnDate)) + accumulator, 0)
    },
    itemsInQuote: (state) => {
        return Object.values(state.items).filter(item => item.assetId).length
    }
}

const actions = {
    addToQuote({ commit }, {assetId, pickupDate, returnDate}) {
        commit('addItem', {assetId, pickupDate, returnDate})
    },
    removeFromQuote({ commit }, assetId) {
        commit('removeItem', assetId)
    },
    async requestListing({ commit }, requestForm) {
        const response = await axios.post(window.envConfig.API_BASEURL + '/api/request/listing', requestForm, { withCredentials: true });
    },
    async requestQuote({ commit }, requestForm) {
        const response = await axios.post(window.envConfig.API_BASEURL + '/api/request/quote', requestForm, { withCredentials: true });
        commit('clearQuote')
    },
};

const mutations = {
    clearQuote(state) {
        state.items = {}
        state.itemsInQuote = Object.keys(state.items).length
        Vue.localStorage.set('quoteItems', state.items);
    },
    addItem(state, {assetId, pickupDate, returnDate}) {
        Vue.set(state.items, assetId, { assetId, pickupDate, returnDate })
        state.itemsInQuote = Object.keys(state.items).length

        // Save items to localstorage
        Vue.localStorage.set('quoteItems', state.items);
    },
    removeItem(state, assetId) {
        Vue.delete(state.items, assetId)
        state.itemsInQuote = Object.keys(state.items).length

        // Save items to localstorage
        Vue.localStorage.set('quoteItems', state.items);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}